import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';

interface MaintenanceListTableBriefBodyPreventiveProps {
  preventives: string[];
}

export const MaintenanceListTableBriefBodyPreventive = ({
  preventives,
}: MaintenanceListTableBriefBodyPreventiveProps) => {
  return (
    <>
      <Box backgroundColor="gray200" paddingY="1-5">
        <Container size="sm">
          <Text as="p" font="bold">
            รายการอะไหล่บำรุงรักษาเชิงป้องกัน
          </Text>
        </Container>
      </Box>
      <Box paddingLeft="7" border="b-1" borderColor="gray300">
        {preventives.map((preventive, index) => (
          <Box key={`preventiveItem${index}`} paddingY="3" paddingLeft="7">
            <Text>{preventive}</Text>
          </Box>
        ))}
      </Box>
    </>
  );
};

MaintenanceListTableBriefBodyPreventive.displayName =
  'SectionMaintenanceListTableBriefBodyPreventive';
